import {
  FactsApi,
  PersonFactResponse,
  CreatePersonFactRequest,
  UpdatePersonFactRequest,
  PersonFactListResponse
} from 'we-tree-api-client/v2';

import { getApiConfiguration } from '@/services/SessionService';
import { ApiResult, withApiSetup } from './apiWrapper';

/**
 * Wrapped person facts API with standardized error handling
 */
class WrappedPersonFactsApi {
  /**
   * Get all facts for a person
   */
  async listPersonFacts(familyMemberId: string): Promise<ApiResult<PersonFactListResponse>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.listPersonFacts(familyMemberId)
    );
  }

  /**
   * Get a person fact by ID
   */
  async getPersonFact(personFactId: string): Promise<ApiResult<PersonFactResponse>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.getPersonFact(personFactId)
    );
  }

  /**
   * Create a new person fact
   */
  async createPersonFact(factData: CreatePersonFactRequest): Promise<ApiResult<PersonFactResponse>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.createPersonFact(factData)
    );
  }

  /**
   * Update an existing person fact
   */
  async updatePersonFact(
    personFactId: string,
    factData: UpdatePersonFactRequest
  ): Promise<ApiResult<PersonFactResponse>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.updatePersonFact(personFactId, factData)
    );
  }

  /**
   * Delete a person fact
   */
  async deletePersonFact(personFactId: string): Promise<ApiResult<void>> {
    return withApiSetup(
      (config) => new FactsApi(config),
      getApiConfiguration,
      (api) => api.deletePersonFact(personFactId)
    );
  }
}

/**
 * Wrapped person facts API instance with standardized error handling
 */
export const personFactsApi = new WrappedPersonFactsApi();

export default personFactsApi;
